import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Leaderboard from './pages/Leaderboard';
import QuestBoard from './pages/QuestBoard';
import Contributions from './pages/Contributions';
import Library from './pages/Library';
import Pods from './pages/Pods';
import Members from './pages/Members';
import Interns from './pages/Interns';
import FAQ from './pages/FAQ';
import Messages from './pages/Messages';
import Events from './pages/Events';
import Trends from './pages/Trends';
import Waitlist from './pages/Waitlist';
import Reports from './pages/Reports';
import Welcome from './pages/Welcome';
import SSOCallback from './pages/SSOCallback';
import ChangePassword from './pages/ChangePassword';
import Layout from './components/Layout';
import './App.css';

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="boot-screen"><div className="boot-spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.mustChangePassword) return <Navigate to="/change-password" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="quests" element={<QuestBoard />} />
            <Route path="contributions" element={<Contributions />} />
            <Route path="library" element={<Library />} />
            <Route path="pods" element={<Pods />} />
            <Route path="members" element={<Protected roles={['cwg','stakeholder','sme']}><Members /></Protected>} />
            <Route path="interns" element={<Interns />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="messages" element={<Messages />} />
            <Route path="events" element={<Events />} />
            <Route path="trends" element={<Trends />} />
            <Route path="waitlist" element={<Protected roles={['cwg','stakeholder']}><Waitlist /></Protected>} />
            <Route path="reports" element={<Protected roles={['cwg','stakeholder','sme']}><Reports /></Protected>} />
          </Route>
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/sso-callback" element={<SSOCallback />} />
          <Route path="/change-password" element={<ChangePassword />} />
          {/* Any unknown path falls back to the landing page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
